import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthenticationService } from '../authentication/services/authentication.service';
import { AccountOnboardingStateService } from './account-onboarding-state.service';

export const accountOnboardingGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthenticationService);
  const router = inject(Router);
  const onboarding = inject(AccountOnboardingStateService);
  if (!auth.getProfileState()?.id) return true;
  try {
    if ((await onboarding.requiredStep(true)) === 'complete') return true;
  } catch {
    // An unavailable check is unknown, never a completed setup.
  }
  return router.createUrlTree(['/account-setup'], {
    queryParams: { returnUrl: state.url },
  });
};
